<template>
    <v-container grid-list-xl fluid>

        <v-layout>
            <v-flex>
                <h3 class="pr-3">{{ $t('menu.event_list') }}</h3>
            </v-flex>
            <v-spacer></v-spacer>
            <v-btn color="primary" :to="{name: 'poll_list'}">{{$t('menu.pre_event_poll')}}</v-btn>
        </v-layout>

        <v-btn-toggle class="mb-4" v-model="event_list.display_event_type" mandatory>
            <v-btn flat value="1">
                {{$t('event.live_event')}}
            </v-btn>
            <v-btn flat value="2">
                {{$t('event.past_event')}}
            </v-btn>
        </v-btn-toggle>

        <ajax-data-iterator
                ref="eventListIterator"
                :get_url="get_events_url"
                :url_query="event_list.params"
                content_tag="v-layout"
                content_class="row wrap"
                :rows_per_page_items="[6]"
                class="mb-5"
        >
            <template slot-scope="props">
                <v-flex xs12 sm6 md4>
                    <v-card>
                        <v-img
                                :src="props.item.cover_file ? props.item.cover_file.absolute_url : '/images/background/bg.jpg'"
                                gradient="to top, rgba(0,0,0,.8) 0, rgba(0,0,0,.6) 40%, rgba(0,0,0,0)"
                                aspect-ratio="2.75"
                        >
                            <v-container fill-height fluid>
                                <v-layout fill-height>
                                    <v-flex xs12 align-self-end flexbox>
                                        <span class="headline white--text">{{props.item.title}}</span>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-img>

                        <v-card-title primary-title>
                            <div class="labeled-text">
                                <v-icon>date_range</v-icon>
                                <span>{{props.item.start_timestamp | moment("lll")}}</span>
                            </div>
                        </v-card-title>

                        <v-card-actions>
                            <v-btn flat color="primary" :to="{name: 'event_manage', query: {event_id: props.item.id}}" target="_blank">{{$t('action.manage')}}</v-btn>
                            <v-spacer></v-spacer>
                            <v-menu
                                    transition="scale-transition"
                                    bottom
                                    right
                            >
                                <v-btn
                                        flat
                                        color="primary"
                                        slot="activator"
                                        icon
                                >
                                    <v-icon>more_vert</v-icon>
                                </v-btn>
                                <v-list>
                                    <v-list-tile @click="editItem(props.item)"><v-icon class="pr-1 fa-fw">edit</v-icon> {{$t('action.edit')}}</v-list-tile>
                                    <v-list-tile @click="openCopyOptionDialog(props.item)"><v-icon class="pr-1 fa-fw">file_copy</v-icon> {{$t('action.copy')}}</v-list-tile>
                                    <v-list-tile v-if="props.item.event_removable" @click="removeItem(props.item)"><v-icon class="pr-1 pb-1 fa-fw">delete</v-icon> {{$t('action.delete')}}</v-list-tile>
                                </v-list>

                            </v-menu>


<!--                            <v-btn flat color="primary" @click="editItem(props.item)">{{$t('action.edit')}}</v-btn>-->
<!--                            <v-btn flat color="primary" @click="editItem(props.item, true)">{{$t('action.copy')}}</v-btn>-->
<!--                            <v-btn v-if="props.item.event_removable" flat color="red" @click="removeItem(props.item)">{{$t('action.delete')}}</v-btn>-->
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </template>
        </ajax-data-iterator>

        <v-btn
                color="primary"
                dark
                fab
                fixed
                right
                bottom
                @click="editItem(null, true)"
                class="mb-5"
        >
            <v-icon>add</v-icon>
        </v-btn>

        <save-event-dialog ref="save_event_dialog"
                           :event_item="current_event_item"
                           :show_dialog="show_edit_event_dialog"
                           :save_success_callback="save_event_success_callback"
                           :is_new_item="is_new_item"
                           v-on:update:show_dialog="show_edit_event_dialog = $event"
        ></save-event-dialog>

        <v-dialog v-model="copy_event_option_dialog.show" scrollable max-width="600px" :fullscreen="$vuetify.breakpoint.smAndDown">
            <v-card>
                <v-card-title
                        class="headline blue darken-2 white--text"
                >
                    {{$t('event.copy_event')}}
                </v-card-title>
                <v-card-text class="v-dialog-body">
                    <v-layout row wrap>
                        <v-flex xs12>
                            <p>{{$t('event.copy_event_desc')}}:</p>
                            <v-treeview
                                    expand-icon=""
                                    open-all
                                    v-model="copy_event_option_dialog.selected_options"
                                    :items="copy_event_option_dialog.options"
                                    selected-color="indigo"
                                    selectable
                            >
                            </v-treeview>
<!--                            <v-checkbox v-model="copy_event_option_dialog.options.all" hide-details color="indigo" :label="$t('app.all')"></v-checkbox>-->
<!--                            <v-checkbox v-model="copy_event_option_dialog.options.general_info" hide-details color="indigo" :label="$t('event.general_setting')"></v-checkbox>-->
<!--                            <v-checkbox v-model="copy_event_option_dialog.options.more_event_info" hide-details color="indigo" :label="$t('event.more_event_info')"></v-checkbox>-->
<!--                            <v-checkbox v-model="copy_event_option_dialog.options.advance_setting" hide-details color="indigo" :label="$t('event.advanced_setting')"></v-checkbox>-->
                        </v-flex>
                    </v-layout>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="blue darken-1"
                            flat="flat"
                            @click="copyItem(copy_event_option_dialog.item)"
                            :disabled="copy_event_option_dialog.selected_options.length == 0"
                    >
                        {{$t('action.ok')}}
                    </v-btn>
                    <v-btn
                            color="blue darken-1"
                            flat="flat"
                            @click="closeCopyOptionDislog"
                    >
                        {{$t('action.close')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
    import AjaxDataIterator from '~/components/widgets/data/AjaxDataIterator'
    import SaveEventDialog from '~/components/event/SaveEventDialog'
    import RequestHandler from '~/utils/request-handler'
    import {UrlServices} from "~/utils/url-manager"

    export default {
        components: {
            SaveEventDialog,
            AjaxDataIterator
        },
        data() {
            return {
                events: [],
                event_list: {
                    searching: false,
                    display_event_type: "1",
                    params: {
                        display_live_events: 1,
                        display_past_events: 0
                    }
                },
                show_edit_event_dialog: false,
                current_event_item: {},
                is_new_item: false,
                save_event_success_callback: function() {},
                copy_event_option_dialog: {
                    show: false,
                    selected_options: [
                        0
                    ],
                    // options: {
                    //     all: true,
                    //     general_info: true,
                    //     more_event_info: true,
                    //     advance_setting: true
                    // }
                    options: [{
                        id: 0,
                        name: getApp.$t('app.all'),
                        children: [
                            {
                                id: 'general_setting',
                                name: getApp.$t('event.general_setting'),
                            },
                            {
                                id: 'more_event_info',
                                name: getApp.$t('event.more_event_info'),
                            },
                            {
                                id: 'advanced_setting',
                                name: getApp.$t('event.advanced_setting'),
                            }
                        ]
                    }]
                }
            };
        },
        computed: {
            get_events_url() {
                return UrlServices.createUrl({name: 'api_event_list'});
            },
        },
        methods: {
            copyItem(item) {
                let copy_item = _.extend({}, item);

                if(!_.includes(this.copy_event_option_dialog.selected_options, 'general_setting')){
                    copy_item.title = "";
                    copy_item.start_timestamp = getApp.$moment().format('X');
                    copy_item.end_timestamp = getApp.$moment().add(7200, 'seconds').format('X');
                    copy_item.enrollment_start_timestamp = null;
                    copy_item.enrollment_end_timestamp = null;
                    copy_item.enable_enrollment_time = false;
                    copy_item.enable_for_enrollment = 1;
                    copy_item.location_lat = null;
                    copy_item.location_lng = null;
                    copy_item.location_text = "";
                    copy_item.cover_file_id = null;
                    copy_item.cover_file = null;

                }

                if(!_.includes(this.copy_event_option_dialog.selected_options, 'more_event_info')){
                    copy_item.event_attachments = [];
                    copy_item.event_photos = [];
                    copy_item.description = "";
                }

                if(!_.includes(this.copy_event_option_dialog.selected_options, 'advanced_setting')){
                    copy_item.ask_for_attend = 1;
                    copy_item.enable_select_name_from_invitations = 1;
                    copy_item.allow_invited_contact_only = 1;
                    copy_item.allow_guest_to_join = 1;
                    copy_item.allow_retrieve_registration = 0;
                    copy_item.enable_registration_notify = 0;
                    copy_item.has_quota_limit = false;
                    copy_item.quota = null;
                    copy_item.price_per_head = null;
                    copy_item.enable_submit_payment = 0;
                    copy_item.is_payment_receipt_mandatory = 0;
                    copy_item.enable_custom_field = 0;
                    copy_item.custom_field_label = "";
                    copy_item.activity_mandatory = 0;
                    copy_item.activity_multiple = 0;
                    copy_item.display_media = 1;
                    copy_item.display_registrants = 1;
                    copy_item.display_payment_status = 0;
                    copy_item.display_selected_activity = 0;
                }

                this.editItem(copy_item, true);

                this.closeCopyOptionDislog();
            },
            openCopyOptionDialog(item) {
                this.copy_event_option_dialog.selected_options = [0];
                this.copy_event_option_dialog.show = true;
                this.copy_event_option_dialog.item = item;
            },
            closeCopyOptionDislog() {
                this.copy_event_option_dialog.show = false;
                this.copy_event_option_dialog.item = null;
            },
            editItem(item = null, is_new_item = false) {
                if(item){
                    item = _.extend({}, item);
                }
                this.is_new_item = is_new_item;
                this.current_event_item = item;
                this.show_edit_event_dialog = true;
            },
            removeItem(item) {
                let me = this;
                this.$root.$confirm(
                    this.$t('event.delete_event'),
                    this.$t('event.delete_event_msg', {
                        'event': item.title
                    })).then((confirm) => {
                    if(confirm){
                        RequestHandler.Post(UrlServices.createUrl({'name': 'api_event_delete'}), {
                            'event_id': item.id
                        }, {
                            'success': function(data) {
                                getApp.snackbar = {
                                    show: true,
                                    color: 'green',
                                    text: me.$t('app.msg_delete_success'),
                                    timeout: 3000
                                };
                                me.$refs.eventListIterator.getDataFromApi();
                            },
                            'error': function(data) {
                                getApp.snackbar = {
                                    show: true,
                                    color: 'red',
                                    text: data['msg'],
                                    timeout: 3000
                                };
                            }
                        });
                    }
                })
            }
        },
        mounted() {
            let me = this;
            this.save_event_success_callback = function(data){
                me.$refs.eventListIterator.getDataFromApi();

                let message = "";

                if(data['is_new_record']){
                    message = me.$t('app.msg_create_success');
                } else {
                    message = me.$t('app.msg_edit_success');
                }

                getApp.snackbar = {
                    show: true,
                    color: 'green',
                    text: message,
                    timeout: 3000
                };
            };
        },
        watch: {
            'event_list.display_event_type': function(new_val) {
                if(new_val == 1){
                    this.event_list.params.display_live_events = 1;
                    this.event_list.params.display_past_events = 0;
                } else {
                    this.event_list.params.display_live_events = 0;
                    this.event_list.params.display_past_events = 1;
                }
                this.$refs.eventListIterator.getDataFromApi();
            },
            'copy_event_option_dialog.options.all': function(val) {
                this.copy_event_option_dialog.options.general_info = val;
                this.copy_event_option_dialog.options.more_event_info = val;
                this.copy_event_option_dialog.options.advance_setting = val;
            },
            'copy_event_option_dialog.options.general_info': function(val) {
                this.copy_event_option_dialog.options.all = val;
            }
        }
    }
</script>

<style scoped>
    h3 {
        font-size: 24px;
    }

    .labeled-text {
        display: flex;
        flex: 1 0 auto;
    }

    .labeled-text span {
        padding-left: 5px;
        line-height: 24px;
    }
</style>